import { Component, Inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';

import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { navigation, docketAlertNavigation } from 'app/navigation/navigation';
import { NewsCountService } from './core/services/news-count.service';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';
import { locale as navigationTurkish } from 'app/navigation/i18n/tr';
import { ALNIdentityAuthService } from './core/auth/aln-identity-auth.service';
import { Router } from '@angular/router';
declare var shellAppComponentRouter: Router;
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment as env } from "environments/environment";
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from '@fuse/services/oidc-config.service';
import jwt_decode from 'jwt-decode';
@Component({
    selector: 'app-base',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: any;
    docketAlertNavigation: any;
    // Private
    private _unsubscribeAll = new Subject<any>();
    idleState = 'Not started.';
    lastPing?: Date = null;
    title = 'Session Timeout';
    Show = false;
    public timerInterval: any;
    islandingPage: boolean = false;
    private tokenCheckInterval: any;

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _translateService: TranslateService,
        private _alnIdentityAuthService: ALNIdentityAuthService,
        private _platform: Platform,
        private router: Router, public oidcSecurityService: OidcSecurityService,
        private idle: Idle, private keepalive: Keepalive,
        private _cookieService: CookieService,
        // Injected so the 'news:count' listener is attached at shell bootstrap,
        // before any micro-frontend has had a chance to publish a count
        private _newsCountService: NewsCountService
    ) {
        let params = (new URL(document.location)).searchParams;
        let code = params.get("code");
        this._alnIdentityAuthService.hasBeenInitialized = true;
        const currentPath = window.location.pathname;
        const isOnLoginPage = currentPath.startsWith("/login");
        const isOnSilentRenew = currentPath.indexOf("silent-renew") > -1;
        
        if (isOnLoginPage) {
            this.islandingPage = true;
        }
        else {
            this.islandingPage = false;
        }

        // Don't trigger login if we're on silent-renew page
        if (isOnSilentRenew) {
            console.log('AppComponent: On silent-renew page, skipping auth check');
            shellAppComponentRouter = router;
            this.navigation = navigation;
            return;
        }

        // Only trigger login flow if:
        // 1. Not on login page
        // 2. No auth code present (not in OAuth callback)
        // 3. User is not authorized
        if (code == null) {
            if (!isOnLoginPage) {
                // Give a short delay to allow checkAuth to complete
                setTimeout(() => {
                    if (!this._alnIdentityAuthService.isAuthorized(10)) {
                        console.log('AppComponent: User not authorized, triggering login');
                        this._alnIdentityAuthService.login();
                    }
                }, 500);
            } else {
                // On login page - LoginComponent handle the auth flow
                console.log('AppComponent: On login page, LoginComponent will handle authentication flow');
            }
        }
        
        // //Handling the After Login Redirect and calling login() to initialize tokens
        // if (window.location.pathname == "/") {
        //     if (!this._alnIdentityAuthService.isAuthorized(10)) {
        //         this._alnIdentityAuthService.login();
        //     }
        // }
        // else {
        //     // if user is not authorized and code is null then redirect to landing page
        //     if (!this.islandingPage && code == null) {
        //         if (!this._alnIdentityAuthService.isAuthorized(10)) {
        //             //If rememberLandingPageEmail is not null then redirect to Identity login page              
        //             if(this._cookieService.get('landingPageEmail')  != null && this._cookieService.get('landingPageEmail')  != '') {
        //                 this._alnIdentityAuthService.login();
        //             }
        //             else {
        //                 window.location.href = `${env.clientUrl}/login`;
        //             }
        //         }
        //     }
        // }



        shellAppComponentRouter = router;
        // Get default navigation
        this.navigation = navigation;

        // Get docketAlert navigation        
        this.docketAlertNavigation = docketAlertNavigation;

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        // Register the docketAlert navigation to the service
        this._fuseNavigationService.register('docketAlerts', this.docketAlertNavigation);

        if (window.location.pathname.startsWith("/docketalerts")) {
            // Set the main navigation as our current navigation
            this._fuseNavigationService.setCurrentNavigation('docketAlerts');
        }
        else {
            // Set the docketAlert navigation as our current navigation
            this._fuseNavigationService.setCurrentNavigation('main');
        }

        // Add languages
        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/

        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.
        /**
         setTimeout(() => {
            this._translateService.setDefaultLang('en');
            this._translateService.setDefaultLang('tr');
         });
         */

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

    }

    stay() {
        this.Show = false;
        clearInterval(this.timerInterval);
        this.idle.watch();
    }

    logout() {
        this.Show = false;
        clearInterval(this.timerInterval);
        this._alnIdentityAuthService.logout('idleTimeoutButton');
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.startTokenValidationCheck();

        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.fuseConfig = config;

                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                }
                else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        if (this.tokenCheckInterval) {
            clearInterval(this.tokenCheckInterval);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    private startTokenValidationCheck(): void {
        this.tokenCheckInterval = setInterval(() => {
            // Check if the current URL is the login page, and skip token validation and reload logic
            if (window.location.pathname.startsWith('/login')) {
                return;
            }
            const authenticationToken = sessionStorage.getItem('token');
            const authorizationToken = sessionStorage.getItem('authtoken');
            if ((authenticationToken && this.isTokenExpired(authenticationToken))
                || (authorizationToken && this.isTokenExpired(authorizationToken))
            ) {
                console.error('AppComponent: Token expired, reloading the page');
                window.location.reload(); // Reload the page if the token is expired
            }
        }, 5000); // Check every 5 seconds
    }

    private isTokenExpired(token: string): boolean {
        try {
            const decodedToken: any = jwt_decode(token);
            const currentTimeInSeconds = Math.floor(Date.now() / 1000);
            return decodedToken.exp < currentTimeInSeconds;
        } catch (error) {
            console.error('AppComponent: Error decoding token:', error);
            return true; // Treat as expired if decoding fails
        }
    }

}
